export default {
    auth: {
        accessToken: "",
        merchantId: "",
        isAuthorizing: true,
        isAuthorized: false,
        isServerError: false
    },
    snackbar: {
        snackbarOpen: false,
        snackbarType: "success",
        snackbarMessage: ""
    }
}